import React, { useState } from 'react';

const TaskManager = () => {
  const [tasks, setTasks] = useState([]);
  const [taskName, setTaskName] = useState('');
  const [assignedTo, setAssignedTo] = useState('');
  const [dueDate, setDueDate] = useState('');

  const addTask = () => {
    setTasks([...tasks, { name: taskName, assignedTo, dueDate, completed: false }]);
    setTaskName('');
    setAssignedTo('');
    setDueDate('');
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg mb-6">
      <h2 className="text-3xl font-bold mb-4">Gestor de Tareas y Proyectos</h2>
      <input 
        type="text" 
        placeholder="Nombre de la tarea" 
        value={taskName} 
        onChange={(e) => setTaskName(e.target.value)} 
        className="w-full p-2 mb-2 border rounded" 
      />
      <input 
        type="text" 
        placeholder="Asignar a" 
        value={assignedTo} 
        onChange={(e) => setAssignedTo(e.target.value)} 
        className="w-full p-2 mb-2 border rounded" 
      />
      <input 
        type="date" 
        value={dueDate} 
        onChange={(e) => setDueDate(e.target.value)} 
        className="w-full p-2 mb-4 border rounded" 
      />
      <button onClick={addTask} className="px-4 py-2 bg-blue-500 text-white rounded">Añadir Tarea</button>
      <ul className="mt-4">
        {tasks.map((task, index) => (
          <li key={index} className="border-b py-2">
            {task.name} - Asignado a: {task.assignedTo} - Fecha límite: {task.dueDate}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TaskManager;
